import PropTypes from 'prop-types'
import enhancer from './enhancer'
import Theme from './Theme'

const ThemeLoader = enhancer(Theme)

ThemeLoader.propTypes = {
  theme: PropTypes.string
}

ThemeLoader.defaultProps = {
  theme: process.env.REACT_APP_THEME
}

export default ThemeLoader
